<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off" #form>
  <!-- <h4 class="title second">
    2. Sự phối hợp của cộng đồng trong thực hiện chính sách giáo dục người khuyết tật
  </h4>
  <div nz-row [nzGutter]="['0','0']" class="px-8">
    <nz-radio-group [(ngModel)]="commonFilter.StudentSurveyStatus" [ngModelOptions]="{standalone: true}" class="w-full">
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <label nz-radio [nzValue]="0">Không</label>
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSpan="24">
        <div nz-row [nzGutter]="['0','0']">
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                <label nz-radio [nzValue]="1">Có (Mức độ cụ thể):</label>
              </nz-form-control>
            </nz-form-item >
          </div>
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                <label nz-radio [nzValue]="2">Rất chặc chẽ</label>
              </nz-form-control>
            </nz-form-item >
          </div>
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                <label nz-radio [nzValue]="3">Chặc chẽ</label>
              </nz-form-control>
            </nz-form-item >
          </div>
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                <label nz-radio [nzValue]="4">Chưa chặc chẽ</label>
              </nz-form-control>
            </nz-form-item >
          </div>
        </div>
      </div>
    </nz-radio-group>
  </div>
  <h4 class="title second">
    3. Sự phối hợp của chính quyền và ban, ngành địa phương
  </h4>
  <div nz-row [nzGutter]="['0','0']" class="px-8">
    <nz-radio-group [(ngModel)]="commonFilter.StudentSurveyStatus" [ngModelOptions]="{standalone: true}" class="w-full">
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <label nz-radio [nzValue]="0">Không</label>
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSpan="24">
        <div nz-row [nzGutter]="['0','0']">
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                <label nz-radio [nzValue]="1">Có (Mức độ cụ thể):</label>
              </nz-form-control>
            </nz-form-item >
          </div>
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                <label nz-radio [nzValue]="2">Rất chặc chẽ</label>
              </nz-form-control>
            </nz-form-item >
          </div>
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                <label nz-radio [nzValue]="3">Chặc chẽ</label>
              </nz-form-control>
            </nz-form-item >
          </div>
          <div nz-col nzSpan="6">
            <nz-form-item>
              <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
                <label nz-radio [nzValue]="4">Chưa chặc chẽ</label>
              </nz-form-control>
            </nz-form-item >
          </div>
        </div>
      </div>
    </nz-radio-group>
  </div> -->
  <h4 class="title second">
    E. KẾT LUẬN VỀ NHU CẦU HỖ TRỢ (Cán bộ thực hiện khảo sát đề xuất dựa trên thực trạng khả năng và nhu cầu của người khuyết tật)
  </h4>
  <div nz-row [nzGutter]="['0','0']" class="px-8">
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-control nzSpan="24">
            <label nz-checkbox [(ngModel)]="survey.isMedicalIntervention" [ngModelOptions]="{standalone: true}">Can thiệp về y tế(Khám, phẩu thuật, PHCN,...), ghi rõ</label>
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSpan="24">
        <div nz-row [nzGutter]="['0','0']">
          <div nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-control nzSpan="24">
                <textarea rows="6" nz-input [(ngModel)]="survey.medicalInterventionDescription" [ngModelOptions]="{standalone: true}"></textarea>
              </nz-form-control>
            </nz-form-item >
          </div>
        </div>
      </div>
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-control nzSpan="24">
            <label nz-checkbox [(ngModel)]="survey.isEducationalSupport" [ngModelOptions]="{standalone: true}">Hỗ trợ giáo dục (GDHN, GDCB,...), ghi rõ:</label>
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSpan="24">
        <div nz-row [nzGutter]="['0','0']">
          <div nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-control nzSpan="24">
                <textarea rows="6" nz-input [(ngModel)]="survey.educationalSupportDescription" [ngModelOptions]="{standalone: true}"></textarea>
              </nz-form-control>
            </nz-form-item >
          </div>
        </div>
      </div>
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-control nzSpan="24">
            <label nz-checkbox [(ngModel)]="survey.isSocialAssistance" [ngModelOptions]="{standalone: true}">Trợ cấp xã hội, ghi rõ</label>
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSpan="24">
        <div nz-row [nzGutter]="['0','0']">
          <div nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-control nzSpan="24">
                <textarea rows="6" nz-input [(ngModel)]="survey.socialAssistanceDescription" [ngModelOptions]="{standalone: true}"></textarea>
              </nz-form-control>
            </nz-form-item >
          </div>
        </div>
      </div>
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-control nzSpan="24">
            <label nz-checkbox [(ngModel)]="survey.isSpecialVehicles" [ngModelOptions]="{standalone: true}">Phương tiện thiết bị đặt thù, ghi rõ</label>
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSpan="24">
        <div nz-row [nzGutter]="['0','0']">
          <div nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-control nzSpan="24">
                <textarea rows="6" nz-input [(ngModel)]="survey.specialVehiclesDescription" [ngModelOptions]="{standalone: true}"></textarea>
              </nz-form-control>
            </nz-form-item >
          </div>
        </div>
      </div>
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-control nzSpan="24">
            <label nz-checkbox [(ngModel)]="survey.isOtherSupport" [ngModelOptions]="{standalone: true}">Khác (Cụ thể)</label>
          </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSpan="24">
        <div nz-row [nzGutter]="['0','0']">
          <div nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-control nzSpan="24">
                <textarea rows="6" nz-input [(ngModel)]="survey.otherSupportDescription" [ngModelOptions]="{standalone: true}"></textarea>
              </nz-form-control>
            </nz-form-item >
          </div>
        </div>
      </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <popup-btn-footer [isDisableUpdate]="false" [isUpdateAndClose]="true" (updateAndClose)="UpdateClose()" (close)="close()"></popup-btn-footer>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <popup-btn-footer [isDisableUpdate]="false" [isUpdateAndClose]="true" (updateAndClose)="UpdateClose()" (close)="close()"></popup-btn-footer>
    </div>
  </div>
</form>